/* Stylesheet */

.toast_message {
  position: absolute;
  padding: 8px 21px 8px 21px;
  margin: 0 auto;
  left: 0;
  right: 0;
  width: 100%;
  bottom: 12px;
  border-radius: 52px;
  box-shadow: var(--ion-box-shadow);
  z-index: 100;

  .grid_container {
    padding: 0;

    .row {
      .col {
        display: flex;
        align-items: center;
      }

      .close_col {
        justify-content: flex-end;
      }

      .icon {
        height: 24px;
        width: 24px;
      }
    }
  }
}

/* Media Queries */
@media screen and (min-width: 1200px) {
  .toast_message {
    width: 50%;
  }
}
